var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomOut = function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.931 2.02a8.91 8.91 0 0 1 8.912 8.91 8.87 8.87 0 0 1-2.203 5.861l4.107 4.106a.6.6 0 0 1-.85.848l-4.104-4.105a8.88 8.88 0 0 1-5.862 2.203 8.912 8.912 0 0 1 0-17.823m0 1.199a7.713 7.713 0 0 0 0 15.425 7.69 7.69 0 0 0 5.398-2.207q.021-.03.05-.06.03-.028.06-.052a7.69 7.69 0 0 0 2.205-5.394 7.713 7.713 0 0 0-7.713-7.712m3.118 7.112a.6.6 0 0 1 0 1.2H7.815a.6.6 0 1 1 0-1.2z"
  })));
};
export default SvgZoomOut;